module.exports = __webpack_public_path__ + "static/media/bg.d1c831b9.png";